import React, { useContext, useState } from "react"
import i18n from "i18n"
import BankPricesContext from "context/bankPrices/bankPricesContext"
import UserDatabaseOptions from "./dropdowns/UserDatabaseOptions"
import ModalImportAll from "./modals/modalImportAll"
import { Box, Button } from "@mui/material"

const LayoutMiBancoDePrecios = ({}) => {
  const { myPricesBank } = useContext(BankPricesContext)
  const [openImport, setOpenImport] = useState(false)
  return (
    <>
      <Box sx={{ maxHeight: "750px", height: "750px", display: "contents" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mb: "30px",
          }}
        >
          {myPricesBank.subcapitulos.length > 0 && (
            <Button
              color="branded"
              variant="contained"
              onClick={() => {
                setOpenImport(true)
              }}
            >
              {i18n.t("Importar")}
            </Button>
          )}
          {myPricesBank.subcapitulos.length > 0 && (
            <Box sx={{ marginTop: "0px", marginLeft: "10px" }}>
              <UserDatabaseOptions />
            </Box>
          )}
        </Box>
      </Box>
      {openImport && (
        <ModalImportAll open={openImport} setOpen={setOpenImport} />
      )}
    </>
  )
}

export default LayoutMiBancoDePrecios
